export default __webpack_public_path__ + "static/media/unequal-sa.5384fff6.jpg";